export const resetState = ({ commit }) => {
  commit('tabs/RESET_STATE')
  commit('permission/RESET_STATE')
  commit('user/RESET_STATE')
}
